import React from "react"

import { FeatureGalleryItem } from "../../../components/_V2/FeaturesGallery"
import { StaticImage } from "gatsby-plugin-image"

import mediaContent from "./mediaContent.module.scss"
import styles from "./styles.module.scss"
import {Locales} from "../../../localization/types";
import classNames from "classnames";

export const getData = (locale: Locales) => {
	if (locale === 'ru-KZ') {
		return {
			features: [
				{
					desktopContentWidth: 600,
					desktopTitle: "Ускоряем бухгалтерию",
					desktopContent: (
						<>
							<p className={mediaContent.mediumDescription}>
								Бухгалтер поблагодарит за&nbsp;использование Quick Resto. <br />
								В&nbsp;системе реализованы двусторонний обмен документами
								и&nbsp;онлайн-выгрузка в&nbsp;1С. Поддерживаем продукты:
							</p>
							<ul className={classNames(mediaContent.ulKz)}>
								<li>1С Предприятие 8.3. Бухгалтерия для Казахстана <span className={mediaContent.nowrap}>(базовая / КОРП / ПРОФ)</span></li>
							</ul>
						</>
					),
					mediaContent: (
						<StaticImage
							className={mediaContent.image}
							src="./assets/integrations-accounting-1.png"
							alt={"интеграция quick resto и 1С"}
							objectFit={"contain"}
							placeholder={"blurred"}
							quality={90}
						/>
					),
					backdropContent: <div className={styles.backdrop} />,
				},
			]
		}  as {
			features: Array<FeatureGalleryItem>
		}
	} else if (locale === 'ru-BY') {
		return {
			features: [
				{
					desktopContentWidth: 600,
					tabName: "1С",
					desktopTitle: "Бухгалтерия останется довольна",
					desktopContent: (
						<>
							<p className={mediaContent.mediumDescription}>
								Бухгалтер поблагодарит за&nbsp;использование Quick Resto. <br />
								В&nbsp;системе реализованы двусторонний обмен документами
								и&nbsp;онлайн-выгрузка в&nbsp;1С. Поддерживаем продукты:
							</p>
							<ul className={mediaContent.ulBy}>
								<li>Бухгалтерия предприятия 3.0</li>
								<li>Управление торговлей 11.2 и&nbsp;11.3</li>
								<li>ERP 2.0</li>
								<li>1С:Общепит 3.0</li>
							</ul>
						</>
					),
					mediaContent: (
						<StaticImage
							className={mediaContent.image}
							src="./assets/integrations-accounting-1.png"
							alt={"интеграция quick resto и 1С"}
							objectFit={"contain"}
							placeholder={"blurred"}
							quality={90}
						/>
					),
					backdropContent: <div className={styles.backdrop} />,
				},
			]
		} as {
			features: Array<FeatureGalleryItem>
		}
	}

	return {
		features: [
			{
				desktopContentWidth: 600,
				tabName: "1С",
				desktopTitle: "Сплошная радость \nдля бухгалтерии",
				desktopContent: (
					<>
						<p className={mediaContent.mediumDescription}>
							Бухгалтер поблагодарит за&nbsp;использование Quick Resto. <br />
							В&nbsp;системе реализованы двусторонний обмен документами
							и&nbsp;онлайн-выгрузка в&nbsp;1С. Поддерживаем продукты:
						</p>
						<ul className={mediaContent.ul}>
							<li>Бухгалтерия предприятия 3.0</li>
							<li>Управление торговлей 11.2 и&nbsp;11.3</li>
							<li>ERP 2.0</li>
							<li>1С:Общепит 3.0</li>
							<li>1С:Фреш</li>
						</ul>
					</>
				),
				mediaContent: (
					<StaticImage
						className={mediaContent.image}
						src="./assets/integrations-accounting-1.png"
						alt={"интеграция quick resto и 1С"}
						objectFit={"contain"}
						placeholder={"blurred"}
						quality={90}
					/>
				),
				backdropContent: <div className={styles.backdrop} />,
			},
			{
				desktopContentWidth: 600,
				tabName: "Эвотор",
				desktopTitle: "Всё сходится!",
				desktopContent: (
					<p className={mediaContent.mediumDescription}>
						Решения Quick Resto адаптированы для работы на&nbsp;термианалах
						Эвотор. Доступны виджеты и&nbsp;отчёты по&nbsp;продажам для
						мониторинга бизнеса. Сотрудники заведения могут вести учёт списания
						ингредиентов, добавлять полуфабрикаты и&nbsp;создавать складские
						документы.
					</p>
				),
				mediaContent: (
					<StaticImage
						className={mediaContent.image}
						src="./assets/integrations-accounting-2.png"
						alt={"интеграция quick resto и эвотор"}
						objectFit={"contain"}
						placeholder={"blurred"}
						quality={90}
					/>
				),
				backdropContent: <div className={styles.backdrop} />,
			},
			{
				desktopContentWidth: 600,
				tabName: "DocsInBox",
				desktopTitle: "Оки доки",
				desktopContent: (
					<p className={mediaContent.smallDescription}>
						DocsInBox&nbsp;&mdash; это облачное решение для документооборота
						с&nbsp;поставщиками продуктов и&nbsp;системой Меркурий. Можно
						загружать приходные накладные без необходимости вносить
						их&nbsp;вручную.
					</p>
				),
				mediaContent: (
					<>
						<StaticImage
							className={mediaContent.image}
							src="./assets/integrations-accounting-3.png"
							alt={"интеграция quick resto и docsinbox"}
							objectFit={"contain"}
							placeholder={"blurred"}
							quality={90}
						/>
					</>
				),
				backdropContent: <div className={styles.backdrop} />,
			},
		],
	} as {
		features: Array<FeatureGalleryItem>
	}
}
